// Hypnotic, jewel-toned "royalty" profile themes.
// Each entry carries BOTH raw hex tokens (used by ProfileEdit inline-style picker/preview
// and avatar glow) AND literal Tailwind class strings (used to restyle the public profile).
// The class strings MUST stay literal here so Tailwind's JIT compiles them.

export const PROFILE_THEMES = {
  "Midnight Gold": {
    id: "midnight_gold",
    vibe: "Royal Obsidian & Liquid Sunbeam",
    // raw hex (ProfileEdit + halos)
    background: "#0B090A", surface: "#161314", border: "#D4AF37", text: "#FFF7E6", accent: "#F5C542",
    glow: "rgba(217,119,6,0.30)", glow2: "rgba(234,179,8,0.20)", ring: "#f59e0b",
    desc: "Royal obsidian dripping with liquid gold.",
    // tailwind tokens (public profile)
    pageBg: "#0B090A",
    ambientGlow: "from-amber-500/20 via-yellow-600/10 to-transparent",
    cardSurface: "bg-[#161314]/80 border-amber-500/30 shadow-[0_8px_32px_rgba(217,119,6,0.15)]",
    accentPrimary: "bg-gradient-to-r from-amber-400 via-yellow-500 to-amber-600 text-black font-bold",
    accentSecondary: "border-amber-400/40 text-amber-300 hover:bg-amber-400/10",
    textPrimary: "text-amber-50", textAccent: "text-amber-400",
    badge: "bg-amber-500/20 text-amber-300 border-amber-500/40",
  },
  "Crimson Velvet": {
    id: "crimson_velvet",
    vibe: "Erotic Romance & Deep Ruby Opulence",
    background: "#0F0407", surface: "#1C080E", border: "#E11D48", text: "#FFF1F2", accent: "#FB7185",
    glow: "rgba(225,29,72,0.32)", glow2: "rgba(190,18,60,0.20)", ring: "#f43f5e",
    desc: "Deep ruby opulence for pure seduction.",
    pageBg: "#0F0407",
    ambientGlow: "from-rose-600/25 via-red-900/15 to-transparent",
    cardSurface: "bg-[#1C080E]/80 border-rose-500/30 shadow-[0_8px_32px_rgba(225,29,72,0.18)]",
    accentPrimary: "bg-gradient-to-r from-rose-500 via-red-600 to-rose-700 text-white font-bold",
    accentSecondary: "border-rose-500/40 text-rose-300 hover:bg-rose-500/10",
    textPrimary: "text-rose-50", textAccent: "text-rose-400",
    badge: "bg-rose-500/20 text-rose-300 border-rose-500/40",
  },
  "Sapphire Secret": {
    id: "sapphire_secret",
    vibe: "Hypnotic Deep Sea & Electric Cobalt",
    background: "#030A16", surface: "#09152B", border: "#2563EB", text: "#EFF6FF", accent: "#60A5FA",
    glow: "rgba(37,99,235,0.32)", glow2: "rgba(6,182,212,0.20)", ring: "#3b82f6",
    desc: "Hypnotic cobalt depths, mysterious and cool.",
    pageBg: "#030A16",
    ambientGlow: "from-blue-600/25 via-indigo-900/15 to-transparent",
    cardSurface: "bg-[#09152B]/80 border-blue-500/30 shadow-[0_8px_32px_rgba(37,99,235,0.18)]",
    accentPrimary: "bg-gradient-to-r from-blue-500 via-indigo-600 to-cyan-500 text-white font-bold",
    accentSecondary: "border-blue-500/40 text-blue-300 hover:bg-blue-500/10",
    textPrimary: "text-blue-50", textAccent: "text-blue-400",
    badge: "bg-blue-500/20 text-blue-300 border-blue-500/40",
  },
  "Emerald Royalty": {
    id: "emerald_royalty",
    vibe: "Lavish Imperial Jade & Mystic Forest Gold",
    background: "#02120B", surface: "#062417", border: "#10B981", text: "#ECFDF5", accent: "#34D399",
    glow: "rgba(16,185,129,0.32)", glow2: "rgba(5,150,105,0.20)", ring: "#10b981",
    desc: "Imperial jade — lavish, rich, regal.",
    pageBg: "#02120B",
    ambientGlow: "from-emerald-600/25 via-teal-900/15 to-transparent",
    cardSurface: "bg-[#062417]/80 border-emerald-500/30 shadow-[0_8px_32px_rgba(16,185,129,0.18)]",
    accentPrimary: "bg-gradient-to-r from-emerald-400 via-teal-500 to-green-600 text-slate-950 font-bold",
    accentSecondary: "border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/10",
    textPrimary: "text-emerald-50", textAccent: "text-emerald-400",
    badge: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40",
  },
  "Amethyst Enchantress": {
    id: "amethyst_enchantress",
    vibe: "Seductive Violet & Spellbinding Cyber Lavender",
    background: "#0B0414", surface: "#180A2A", border: "#A855F7", text: "#FAF5FF", accent: "#C084FC",
    glow: "rgba(168,85,247,0.32)", glow2: "rgba(217,70,239,0.20)", ring: "#a855f7",
    desc: "Spellbinding violet — hypnotic and enchanting.",
    pageBg: "#0B0414",
    ambientGlow: "from-purple-600/25 via-fuchsia-900/15 to-transparent",
    cardSurface: "bg-[#180A2A]/80 border-purple-500/30 shadow-[0_8px_32px_rgba(168,85,247,0.18)]",
    accentPrimary: "bg-gradient-to-r from-purple-500 via-fuchsia-600 to-pink-500 text-white font-bold",
    accentSecondary: "border-purple-500/40 text-purple-300 hover:bg-purple-500/10",
    textPrimary: "text-purple-50", textAccent: "text-purple-300",
    badge: "bg-purple-500/20 text-purple-300 border-purple-500/40",
  },
  "Neon Desire": {
    id: "neon_desire",
    vibe: "Cyberpunk Passion & Magenta Pulsar",
    background: "#0F0211", surface: "#1F0724", border: "#D946EF", text: "#FDF4FF", accent: "#E879F9",
    glow: "rgba(217,70,239,0.34)", glow2: "rgba(236,72,153,0.22)", ring: "#d946ef",
    desc: "High-octane magenta pulsar — electric and bold.",
    pageBg: "#0F0211",
    ambientGlow: "from-fuchsia-600/30 via-pink-600/20 to-transparent",
    cardSurface: "bg-[#1F0724]/80 border-fuchsia-500/40 shadow-[0_8px_32px_rgba(217,70,239,0.22)]",
    accentPrimary: "bg-gradient-to-r from-fuchsia-500 via-pink-500 to-rose-500 text-white font-extrabold",
    accentSecondary: "border-fuchsia-500/40 text-fuchsia-300 hover:bg-fuchsia-500/10",
    textPrimary: "text-pink-50", textAccent: "text-fuchsia-400",
    badge: "bg-fuchsia-500/20 text-fuchsia-300 border-fuchsia-500/40",
  },
  "Rose Gold": {
    id: "rose_gold",
    vibe: "Blush Opulence & Warm Rose Gold",
    background: "#140A0E", surface: "#231318", border: "#E8B4B8", text: "#FFF5F2", accent: "#F0C9A8",
    glow: "rgba(232,180,184,0.30)", glow2: "rgba(217,164,138,0.20)", ring: "#e8b4b8",
    desc: "Soft blush meets warm rose gold — romantic and luxe.",
    pageBg: "#140A0E",
    ambientGlow: "from-rose-300/25 via-amber-200/10 to-transparent",
    cardSurface: "bg-[#231318]/80 border-rose-200/30 shadow-[0_8px_32px_rgba(232,180,184,0.16)]",
    accentPrimary: "bg-gradient-to-r from-rose-200 via-amber-200 to-rose-300 text-stone-900 font-bold",
    accentSecondary: "border-rose-200/40 text-rose-200 hover:bg-rose-200/10",
    textPrimary: "text-rose-50", textAccent: "text-rose-200",
    badge: "bg-rose-200/15 text-rose-100 border-rose-200/40",
  },
  "Ivory & Pearl": {
    id: "ivory_pearl",
    vibe: "Bright Ivory & Pearl Luxe",
    background: "#F7F1E8", surface: "#FFFFFF", border: "#C9A227", text: "#1C1917", accent: "#B8860B",
    glow: "rgba(201,162,39,0.22)", glow2: "rgba(180,140,90,0.14)", ring: "#C9A227",
    desc: "Soft ivory & pearl with gold — bright, clean and elegant.",
    pageBg: "#F7F1E8",
    ambientGlow: "from-amber-200/40 via-stone-100/20 to-transparent",
    cardSurface: "bg-white/80 border-stone-300/70 shadow-[0_8px_32px_rgba(180,140,10,0.12)]",
    accentPrimary: "bg-gradient-to-r from-amber-500 via-yellow-600 to-amber-700 text-white font-bold",
    accentSecondary: "border-amber-600/50 text-amber-800 hover:bg-amber-600/10",
    textPrimary: "text-stone-900", textAccent: "text-amber-700",
    badge: "bg-amber-500/15 text-amber-800 border-amber-600/40",
  },
  "Obsidian Noir": {
    id: "obsidian_noir",
    vibe: "All-Black Minimal & Platinum Edge",
    background: "#000000", surface: "#0C0C0C", border: "#3F3F46", text: "#F4F4F5", accent: "#E5E7EB",
    glow: "rgba(255,255,255,0.10)", glow2: "rgba(160,160,160,0.08)", ring: "#a1a1aa",
    desc: "Pure black minimalism with a platinum edge.",
    pageBg: "#000000",
    ambientGlow: "from-zinc-500/15 via-zinc-700/10 to-transparent",
    cardSurface: "bg-[#0C0C0C]/85 border-zinc-700/50 shadow-[0_8px_32px_rgba(255,255,255,0.05)]",
    accentPrimary: "bg-gradient-to-r from-zinc-100 via-white to-zinc-200 text-black font-bold",
    accentSecondary: "border-zinc-500/50 text-zinc-200 hover:bg-zinc-500/10",
    textPrimary: "text-zinc-100", textAccent: "text-zinc-300",
    badge: "bg-zinc-500/15 text-zinc-200 border-zinc-500/40",
  },
};

export const THEME_NAMES = Object.keys(PROFILE_THEMES);
export const DEFAULT_THEME = "Midnight Gold";

// Resolve a stored theme name (handles legacy/missing values like "Lace & Pearl").
export const getTheme = (name) => PROFILE_THEMES[name] || PROFILE_THEMES[DEFAULT_THEME];
